module.exports = __webpack_public_path__ + "media/images/icons/outlined/disconnect-8add8b47afd6ef49a0c1192ebba454a3.svg";